




































































import { Config } from 'client-website-ts-library/services';
import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { BlogFilter } from 'client-website-ts-library/filters';
import { BlogType, WebsiteLevel } from 'client-website-ts-library/types';
import { FormConstructorData } from 'client-website-ts-library/types/Forms';
import { ContextItemType } from 'client-website-ts-library/types/Context';

import Estates from '../components/Estates.vue';
import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    Estates,
    Form,
  },
})
export default class LandEstates extends Mixins(View) {
  private filterCurrent = new BlogFilter({
    SearchLevel: WebsiteLevel.Office,
    SearchGuid: Config.API.WebsiteId,
    Types: [BlogType.Estate],
    Tag: 'Current',
  });

  private filterPast = new BlogFilter({
    SearchLevel: WebsiteLevel.Office,
    SearchGuid: Config.API.WebsiteId,
    Types: [BlogType.Estate],
    Tag: 'Past',
  });

  private formData: FormConstructorData | null = null;

  mounted() {
    this.formData = new FormConstructorData([
      {
        Type: ContextItemType.EnquiryTargetProfile,
        Id: Config.API.WebsiteId,
      },
    ]);
  }

  scrollTo() {
    if (window.location.hash === '#past') {
      const element = document.getElementById('past');
      const top = element!.offsetTop;
      window.scrollTo(0, top - 200);
    }
  }
}
